import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useCallback, useState, useEffect } from 'react';
import useOnce from '@scentregroup/shared/hooks/use-once';
import { Box } from '@hub/box';
import useMobileBreakpoint from '@scentregroup/shared/helpers/use-mobile-breakpoint';
import { makeClients, makeOffsetlessTimeGetters } from '../algolia-helpers';
import useAutocomplete from './use-autocomplete';
import SearchForm from './search-form';
import limitResults from './limit-results';
import useRefsAndCursor from './use-refs-and-cursor';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ROWS_DISPLAY_LIMIT = 15;

function useAlgoliaClients(algoliaApiKeys) {
  const clients = useOnce(() => makeClients(algoliaApiKeys));

  if (!clients) {
    throw new Error('Algolia clients not found');
  }

  return clients;
}

function useOnSubmit(onSubmitBase, query) {
  const onSubmit = _ref => {
    let {
      event
    } = _ref;

    if (query) {
      return onSubmitBase(event, query);
    } else {
      return undefined; // no-op
    }
  };

  return useCallback(onSubmit, [onSubmitBase, query]);
}

const SearchModalAutocomplete = _ref2 => {
  let {
    placeholder,
    algoliaApiKeys,
    baseContext,
    onSubmit: onSubmitBase,
    onClickClose,
    directCategories
  } = _ref2;
  const clients = useAlgoliaClients(algoliaApiKeys);
  const {
    country,
    centre
  } = baseContext;
  const timeGetters = makeOffsetlessTimeGetters(country, centre);

  const searchContext = _objectSpread(_objectSpread({}, baseContext), timeGetters);

  const {
    0: nonDebouncedQuery,
    1: setNonDebouncedQuery
  } = useState('');
  const onSubmit = useOnSubmit(onSubmitBase, nonDebouncedQuery);
  const {
    autocomplete: baseAutocomplete,
    autocompleteState,
    resetState
  } = useAutocomplete(clients, searchContext, onSubmit, directCategories); // see comment in ../types.ts for this cast

  const autocomplete = baseAutocomplete;
  const {
    collections,
    query
  } = autocompleteState;
  const refsAndCursor = useRefsAndCursor(query, collections);
  const collectionsToDisplay = limitResults(collections !== null && collections !== void 0 ? collections : [], ROWS_DISPLAY_LIMIT);
  const isMobile = useMobileBreakpoint();

  const reinitialiseQuery = () => {
    const {
      query
    } = autocompleteState;

    if (query) {
      autocomplete.setQuery(query);
    }
  };

  useEffect(() => {
    autocomplete.refresh(); // Honestly we only want to run this once, when the component first renders
    // We don't care if the dependency changes I promise.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Box, {
      sx: {
        display: 'flex',
        'flex-direction': 'row',
        width: '100%',
        height: 'size-sm',
        'justify-content': 'center',
        'padding-left': 'spacing-md',
        'padding-right': 'spacing-md',
        background: 'white'
      },
      "data-id": "search-modal-autocomplete_index_SearchModalAutocomplete_Box",
      children: /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
        sx: {
          'max-width': '584px',
          width: '100%',
          float: 'left',
          margin: 'auto',
          position: 'relative',
          height: 'size-xs',
          'margin-top': 'spacing-md'
        }
      }, autocomplete.getRootProps(refsAndCursor.autocompleteRefs.getElems())), {}, {
        "data-id": "search-modal-autocomplete_index_SearchModalAutocomplete_Box_Box_1",
        children: /*#__PURE__*/_jsx(SearchForm, {
          refsAndCursor,
          onClickClose,
          autocomplete,
          placeholder,
          query,
          clearQuery: resetState,
          collections: collectionsToDisplay,
          context: baseContext,
          reinitialiseQuery,
          setNonDebouncedQuery,
          "data-id": "search-modal-autocomplete_index_SearchModalAutocomplete_Box_SearchForm"
        })
      }))
    }), isMobile && /*#__PURE__*/_jsx(Box, {
      id: "filler",
      width: '100%',
      height: '100%',
      background: 'white',
      "data-id": "search-modal-autocomplete_index_SearchModalAutocomplete_Box"
    })]
  });
};

export default SearchModalAutocomplete;